<template>
  <span class="rf-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="5" r="2" fill="inherit" stroke="none" />
      <circle cx="12" cy="12" r="2" fill="inherit" stroke="none" />
      <circle cx="12" cy="19" r="2" fill="inherit" stroke="none" />
    </svg>
  </span>
</template>
